import { PathButton } from "shared/react";

export function SettingsMenu(): React.ReactNode {
	return (
		<nav className="flex-column gap-hairline">
			<h2 className="label">Settings</h2>
			<PathButton path="/settings/profile">Edit profile</PathButton>
			<PathButton path="/settings/privacy">Privacy settings</PathButton>
		</nav>
	);
}
